/**
 * Copyright (C) 2019 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'
import scopedCss from 'lui-navigation.scss'
import template from 'lui-navigation.html'

export default class Luinavigation extends LuiBase {
  static get is() {
    return 'lui-navigation'
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-navigation/lui-navigation.js
// module id = 253
// module chunks = 0 1 9